<template>
  <BreadcrumbVue />

  <section class="memorial" aria-labelledby="titulo-memorial">
    <div class="container">
      <header class="hero">
        <h1 id="titulo-memorial" class="hero-title">
          CONHEÇA O MEMORIAL DA EDUCAÇÃO FÍSICA SERGIPANA<br />
          <small>— PROF. DR ROBERTO JERÔNIMO DOS SANTOS SILVA</small>
        </h1>
      </header>

      <div class="row ctas" role="list">
        <div class="col-12 col-md-4 mt-3" role="listitem">
          <div class="cta-card">
            <div class="cta-title">Agende sua visita</div>
            <a class="cta-link" :href="links.agendamento" target="_blank" rel="noopener" aria-label="Acessar agendamento">
              Acessar <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="col-12 col-md-4 mt-3" role="listitem">
          <div class="cta-card">
            <div class="cta-title">Regulamento PDF</div>
            <a class="cta-link" :href="links.regulamento" target="_blank" rel="noopener" aria-label="Abrir regulamento em PDF">
              Acessar <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="col-12 col-md-4 mt-3" role="listitem">
          <div class="cta-card">
            <div class="cta-title">Tour Virtual</div>
            <a class="cta-link" :href="links.tour" target="_blank" rel="noopener" aria-label="Abrir tour virtual">
              Acessar <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>

      <figure class="hero-image mt-4" v-if="imagem.url">
        <img :src="imagem.url" class="img-fluid banner" loading="lazy" />
      </figure>

      <article class="descricao">
        <p v-for="(p, i) in paragrafos" :key="i">{{ p }}</p>
      </article>

      <section class="videos" v-if="hasAnyVideo" aria-labelledby="titulo-videos">
        <h2 id="titulo-videos" class="sr-only">Vídeos do memorial</h2>
        <div class="videos-grid">
          <div class="video-wrapper" v-if="youtubeId1">
            <template v-if="playing1">
              <iframe
                :src="embedSrc1"
                width="100%"
                height="400"
                loading="lazy"
                allow="autoplay; encrypted-media; picture-in-picture; clipboard-write"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
                style="border:0"
              ></iframe>
            </template>
            <template v-else>
              <button class="thumb-btn" type="button" @click="play(1)" :aria-label="'Reproduzir vídeo 1'">
                <img :src="thumbUrl1" alt="" loading="lazy" />
                <span class="play" aria-hidden="true">▶</span>
              </button>
            </template>
          </div>

          <div class="video-wrapper" v-if="youtubeId2">
            <template v-if="playing2">
              <iframe
                :src="embedSrc2"
                width="100%"
                height="400"
                loading="lazy"
                allow="autoplay; encrypted-media; picture-in-picture; clipboard-write"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
                style="border:0"
              ></iframe>
            </template>
            <template v-else>
              <button class="thumb-btn" type="button" @click="play(2)" :aria-label="'Reproduzir vídeo 2'">
                <img :src="thumbUrl2" alt="" loading="lazy" />
                <span class="play" aria-hidden="true">▶</span>
              </button>
            </template>
          </div>
        </div>
      </section>
    </div>
  </section>

  <svg xmlns="http://www.w3.org/2000/svg" width="1411" height="216" viewBox="0 0 1411 216" fill="none" preserveAspectRatio="none" aria-hidden="true">
    <path d="M-1.63184 215.837L1412.09 215.837L1412.09 200.647C952.93 -59.9253 493.774 -71.6101 -1.63184 200.647L-1.63184 215.837Z" fill="#EEEEEE" fill-opacity="0.8"/>
  </svg>

  <Popup />
  <FooterInternas />
</template>

<script>
import FooterInternas from '../components/FooterInternas/FooterInternas.vue'
import BreadcrumbVue from '@/components/Breadcrumb/Breadcrumb.vue'
import Popup from '@/components/Popup/PopupComponent.vue'

export default {
  name: 'MemorialPage',
  components: { FooterInternas, BreadcrumbVue, Popup },
  data() {
    return {
      links: { agendamento: '', regulamento: '', tour: '' },
      imagem: { url: '' },
      paragrafos: [],
      linkVideo1: '',
      linkVideo2: '',
      playing1: false,
      playing2: false
    }
  },
  computed: {
    youtubeId1() { return this.youtubeIdFromUrl(this.linkVideo1) },
    youtubeId2() { return this.youtubeIdFromUrl(this.linkVideo2) },
    thumbUrl1() { return this.youtubeId1 ? `https://img.youtube.com/vi/${this.youtubeId1}/hqdefault.jpg` : '' },
    thumbUrl2() { return this.youtubeId2 ? `https://img.youtube.com/vi/${this.youtubeId2}/hqdefault.jpg` : '' },
    embedSrc1() { return this.youtubeId1 ? `https://www.youtube-nocookie.com/embed/${this.youtubeId1}?autoplay=1&rel=0&modestbranding=1` : '' },
    embedSrc2() { return this.youtubeId2 ? `https://www.youtube-nocookie.com/embed/${this.youtubeId2}?autoplay=1&rel=0&modestbranding=1` : '' },
    hasAnyVideo() { return !!(this.youtubeId1 || this.youtubeId2) }
  },
  methods: {
    youtubeIdFromUrl(raw) {
      if (!raw) return ''
      try {
        const u = new URL(raw)
        if (u.hostname.includes('youtube.com')) return u.searchParams.get('v') || ''
        if (u.hostname === 'youtu.be') return u.pathname.replace('/', '') || ''
        return ''
      } catch { return '' }
    },
    play(n) {
      if (n === 1) this.playing1 = true
      if (n === 2) this.playing2 = true
    }
  },
  async created() {
    try {
      const res = await fetch('https://api.cref20.org.br/wp-json/cref/v1/memorial')
      const data = await res.json()
      if (!data.error) {
        this.links = data.links || this.links
        this.imagem = { url: data?.imagem?.url || '' }
        const texto = data.texto || ''
        this.paragrafos = texto.split('\n').filter(t => t.trim() !== '')
        const vids = Array.isArray(data.videos) ? data.videos : []
        const v0 = vids[0] || {}
        const v1 = vids[1] || {}
        this.linkVideo1 = v0.url || data?.video?.url || data?.link_video || ''
        this.linkVideo2 = v1.url || ''
      }
    } catch (e) {
      console.error('Erro ao carregar memorial:', e)
    }
  }
}
</script>

<style scoped>
svg { width: 100%; }
.memorial { padding-top: 24px; }
.container { max-width: 1140px; }
.hero { text-align: center; }
.hero-title {
  color: #2b2b2b;
  font-weight: 800;
  line-height: 1.25;
  font-size: 28px;
  margin: 0 0 18px;
  text-transform: uppercase;
}
.hero-title small {
  display: inline-block;
  margin-top: 6px;
  font-size: 18px;
  font-weight: 700;
  text-transform: none;
}
.ctas { margin-top: 8px; }
.cta-card {
  border: 1px solid #fcd2d2;
  padding: 15px;
  border-radius: 10px;
  background: #fff;
}
.cta-title {
  color: #45A047;
  font-size: 1rem;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
}
.cta-link {
  display: inline-flex;
  gap: .4rem;
  align-items: center;
  color: #5e5e5e;
  font-size: 18px;
  font-weight: 400;
  text-decoration: none;
  border-bottom: 1px solid #5D5D5D;
  margin-top: 12px;
}
.cta-link .bi-arrow-right { color: #45A047; }
.hero-image { margin-top: 10px; text-align: center; }
.banner { max-width: 720px; width: 100%; height: auto; display: inline-block; border-radius: 6px; }
.descricao {
  color: #575757;
  font-size: 16px;
  line-height: 1.55;
  margin-top: 14px;
  text-align: justify;
}
.descricao p { margin-bottom: .85rem; }
.videos { margin-top: 18px; }
.videos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.video-wrapper {
  aspect-ratio: 16 / 9;
  position: relative;
  background: #000;
  border-radius: 6px;
  overflow: hidden;
}
.thumb-btn {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.video-wrapper img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: .9;
}
.play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 54px;
  line-height: 1;
  color: #fff;
  text-shadow: 0 4px 16px rgba(0,0,0,.4);
}
.sr-only {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;
}
@media (max-width: 765px) {
  svg { display: none; }
  .hero-title { font-size: 24px; }
  .hero-title small { font-size: 16px; }
  .videos-grid { grid-template-columns: 1fr; }
}
</style>
